// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer{padding:.5rem 1.5rem;max-width:1024px;margin-left:auto;margin-right:auto;display:flex;flex-direction:row;justify-content:space-between;font-size:.875rem}.footer__whatsapp{font-size:1em;color:var(--body)}.footer__whatsapp svg{margin-right:.5em}.copyright{font-size:1em;color:var(--body-2);font-weight:300}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
